export function useDateRange(date) {
	if (date?.endDate) {
		return 'custom';
	}

	return 'default';
}
